import React, { useRef, useState } from 'react';
import ButtonWithBorder from './SelectButtonWithBorder';
// import AutoListItem from './AutoListItem';
import SearchDropdown from '/src/common/refactoredComponents/searchDropdown/SearchDropdown.jsx';
import { Box } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import ScanBardCodePopUp from 'src/pages/receiveSets/components/ReceiveSetsLoc/ScanBardCodePopUp.jsx';
import ExternalCamera from 'src/pages/receiveSets/components/notifications/ExternalCamera.jsx';
import MDICheckBold from 'src/assets/images/MDICheckBold.svg';
import { AddInputStyle, ButtonDiv } from './AddItemSearchItem.styled';
import { StyledForm } from 'src/styles/CommonStyles.styled';
import { isIpad, isMobileView, getRoutePathWithParams, logErrorToConsole } from 'src/utils/util';
import { useSelector, useDispatch } from 'react-redux';
import ScanItem from 'src/common/components/scanItems/scanItems';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { useHistory } from 'react-router-dom';
import {
    getBarcodeItems,
} from 'src/common/barCodeScannerRedux/actions/actionCreators';
import {
    resetIsForPriceOverride,
    setInventoryItems,
} from 'src/pages/consignmentBilling/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import BulkAdd from '../../../pages/reportUsage/record/components/addSearchItems/BulkAdd';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { SubText } from 'src/pages/scheduleSurgery/components/surgery/notifications/Notifications.styled.jsx';
import { useTranslation } from 'react-i18next';
import { AddButton } from './AddItemSearchItem.styled';

const AddItemSearchItem = ({
    id,
    buttonList,
    onSearchAddPress,
    isSelected,
    addItemPlaceholder,
    autoCompleteData,
    optionValue,
    autoCompletePlaceholder,
    autoCompleteInputChange,
    onClose,
    onChange,
    onSelectItem,
    open,
    optionLabelKey,
    handleOnOpen,
    addItemChange,
    succesMessage,
    zIndex,
    boxShadow,
    marginLeft,
    marginLeftInput,
    fontSize,
    fontFamily,
    color,
    opacity,
    placeholderMarginLeft,
    lineHeightInputStyle,
    showScrollBar,
    dropdownHeight,
    handleFocus,
    handleBlur,
    isPriceOverride,
    isCondensedView,
    addItemSearchTerm,
    selectedProduct,
    orderType = 'ZLC',
    isBundle,
    setBundleError,
    selectedBundleProduct,
    setDisableDoneButton,
    isReportPayment = false,
    setSuccesMesssage,
    reportPaymentGridData,
    setReportPaymentGridData = () => {},
    filteredProduct,
    setFilteredProduct = () => {},
    setOpen=() => {},
    productSelectedItem = [],
    isBundleProduct=false,
    isConsignmentBilling=false,
    isEquityTemplate=false,
    checkLotSerial=false,
    isReportUsage=false,
    autoCompleteDataLoading,
    bulkAddValue,
    setBulkAddValue,
    activeScanTab,
    setActiveScanTab,
    externalBarcode,
    setExternalBarcode,
}) => { 
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const itemTableData = useSelector(
        (state) => state.consignmentBilling.itemTableData
    );

    const winWidth = window.innerWidth;
    const isIpadMini = winWidth === sizes.smalDevice;
    const isIpadDevice =  winWidth > sizes.mobileDevice && winWidth <= sizes.mediumDevice;
    const addItemRef=useRef();
    const [showExteralCameraPopup, setShowExteralCameraPopup] = useState(false);
    const [scanBarCode, setScanBarCode] = useState(false);
    const [counter, setCounter] = useState(0);
    const [counterMessage, setCounterMessage] = useState('');
    const [cursorOnInput, setCursorOnInput] = useState(false);
    const [invalidItemPopup, setInvalidItemPopup] = useState(false);
    const { t } = useTranslation();
    const history = useHistory();
    const [
        showSuccessMessageExternalScanner,
        setShowSuccessMessageExternalScanner,
    ] = useState(false);
    const [
        showSuccessMessageInScannerScreen,
        setShowSuccessMessageInScannerScreen,
    ] = useState(false);
    const [, setFromManual] = useState(false);
    const dispatch = useDispatch();

    const {
        accountId,
        patientFirstName,
        patientLastName,
        physicianName,
        hrefId,
        isShortTermConsignment,
        loading,
    } = useSelector((state) => ({
        accountId: state.consignmentReducer.surgeryDetails.accountId,
        patientFirstName:
            state.consignmentReducer.surgeryDetails.patientFirstName,
        patientLastName:
            state.consignmentReducer.surgeryDetails.patientLastName,
        physicianName: state.consignmentReducer.surgeryDetails.physicianId,
        hrefId: state.consignmentReducer.surgeryDetails.hrefId,
        isShortTermConsignment:
            state.consignmentReducer.surgeryDetails.isShortTermConsignment,
        loading: state.productsSearchReducer.loading,
    }));

    const barcodeData = useSelector(
        (state) => state.BarCodeScannerReducer.barcodeDetails
    );

    useEffectWithErrorLogging(() => {
        if (barcodeData?.productDetails?.cfn) {
            addItemChange(barcodeData, true);
        } else if (
            barcodeData?.statusCode === '11921' &&
            !scanBarCode &&
            showSuccessMessageExternalScanner
        ) {
            setInvalidItemPopup(true);
        }
    }, [barcodeData]);


        // useEffectWithErrorLogging(() => {
        //     if (barcodeData?.productDetails?.cfn) {
        //         addItemChange(barcodeData, true);
        //     } else if (
        //         barcodeData?.statusCode === '11921' &&
        //         !scanBarCode &&
        //         showSuccessMessageExternalScanner
        //     ) {
        //         setInvalidItemPopup(true);
        //         dispatch(resetBarcodeDetails());
        //     }
        // }, [barcodeData]);  // report usage flow

    const [isFromScannerBarcode, setisFromScannerBarcode] = useState(false);

    const handleExtScanCam = () => {
        setisFromScannerBarcode(true);
        setShowExteralCameraPopup(true);
    };

    //     const handleExtScanCam = () => {
    //     setisFromScannerBarcode(true);
    //     setShowExteralCameraPopup(true);
    //     setShowSuccessMessageInScannerScreen(false);
    // };  // report usage flow

    const handleExternalBarcode = (e) => { 
        setShowSuccessMessageExternalScanner(true);
        setShowSuccessMessageInScannerScreen(false);
        if (e.target.value?.trim().length >= 12) {
            // dispatch(
            //     getBarcodeReceiveSets({
            //         territoryId: territoryId,
            //         accountId: accountId,
            //         barcode: e.target.value?.trim(),
            //         isManual: true,
            //         isBarCode: true,
            //         isExternalBarcode: true,
            //     })   01006431697838431732050610H5944827
            // );

            dispatch(
                getBarcodeItems({
                    barcode: e.target.value?.trim(),
                    orderType: orderType,
                    externalScanner: 'true',
                })
            );
            // document.getElementById('last-barcode').value = '';
            // e.target.value = '';
            // dispatch(resetBarcodeDetails())
            // setCursorOnInput(true);
        }
    };

    // const handleAddBarcodeToList = () => {
    //     setIsBulkDchainAdd(false);
    //     setShowSuccessMessageInScannerScreen(true);
    //     setShowSuccessMessageExternalScanner(false);
    //     setFromManual(true);

    //     dispatch(
    //         getBarcodeReceiveSets({
    //             territoryId: territoryId,
    //             accountId: accountId,
    //             barcode: barcodeNo?.trim(),
    //             isManual: true,
    //             isBulkAdd: false,
    //             // isBarCode: true,
    //         })
    //     );
    //     setBarcodeNo('');
    //     dispatch(resetCreateReceiveSets());
    //     setIsBulkAdd(false);
    // };

    const addItems = t('reportUsage.addItems.title');
    const scanItems = t('reportUsage.searchItems.ScanItems');
    const bulkAdd = t('equity.quickOrder.header.bulkAdd');

    const effectiveLoading =
        autoCompleteDataLoading !== undefined ? autoCompleteDataLoading : loading;


    return (
         <React.Fragment>
            <Box
                className="cardContainer"
                width={winWidth <= sizes.mobileDevice ? '100%' : '50%'}
                isCondensedView={isCondensedView}
                boxShadow={boxShadow ? boxShadow : 2}
                padding={'8px 16px 20px !important'}
            >
                <Box
                    className="pb-0 cardHeader"
                    marginLeft={marginLeft}
                    style={{
                        width: 
                            isIpadMini && !isBundle? '250px' : 
                            isEquityTemplate ? '350px' : 
                            (orderType === 'KE' && (winWidth > sizes.mediumDevice) ) 
                                ?'275px':
                            (orderType === 'KE' && (winWidth > sizes.mobileDevice) && (winWidth <= sizes.mediumDevice)) 
                                ? '250px' :  
                            (((winWidth <= sizes.mobileDevice) && orderType === 'KE') ||
                            ((winWidth > sizes.mobileDevice) && (winWidth <= sizes.mediumDevice) && isBundle))
                                ? 'fit-content' : 
                            '',
                        display: 'flex',
                        justifyContent:  !isEquityTemplate && !isBundle && 'space-between',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <ButtonWithBorder
                        buttonList={buttonList}
                        buttonClick={onSearchAddPress}
                        isSelected={isSelected}
                    />
                    {orderType === 'KE' && !isPriceOverride && (
                        <div style={{ marginLeft: 'auto' }}>
                            <a
                                id={'consignment-billing-addsearchitem'}
                                // eslint-disable-next-line no-unused-vars
                                onClick={(e) => {
                                    //history.push('/inventory');
                                    history.push({
                                        ...getRoutePathWithParams('/inventory'),
                                        state: {
                                            detail: {
                                                accountId: accountId.accountId,
                                                patientFirstName:
                                                    patientFirstName,
                                                patientLastName:
                                                    patientLastName,
                                                physicianName: physicianName,
                                                accountName:
                                                    accountId.accountName,
                                                hrefId: hrefId,
                                            },
                                        },
                                    });
                                    const newData = itemTableData
                                        .filter((item) => item.isChecked)
                                        .map((itemData) => ({
                                            ...itemData,
                                            used: itemData.lotSerial[0].Used,
                                            lotSerial:
                                                itemData.lotSerial[0].Serial,
                                        }));
                                    if (
                                        newData.some((x) =>
                                            Object.prototype.hasOwnProperty.call(
                                                x,
                                                'isChecked'
                                            )
                                        )
                                    ) {
                                        dispatch(setInventoryItems(newData));
                                    } else {
                                        dispatch(
                                            setInventoryItems(checkedItems)
                                        );
                                    }
                                    dispatch(resetIsForPriceOverride(false));
                                    // dispatch(setInventoryItems(newData));
                                    // dispatch(resetIsForPriceOverride(false));
                                    // dispatch(setPriceItemButtonDisabled(false));
                                }}
                            >
                                {isCondensedView &&
                                    window.innerWidth > sizes.mobileDevice && (
                                        <AddButton
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {t(
                                                'consignmentBilling.billing.addFromInventory'
                                            )}
                                        </AddButton>
                                    )}
                            </a>
                        </div>
                    )}
                </Box>
                <Box
                    paddingTop="0.7rem!important"
                    bgcolor={'#FFF'}
                    width={(winWidth > sizes.mobileDevice && (isIpad() || isIpadDevice) &&
                        (isReportPayment || isReportUsage)) ?
                         '50% !important':'100%'}
                    style={
                        (isSelected !== addItems &&
                        isSelected !== scanItems &&
                        isSelected !== bulkAdd && isBundle)
                            ? { width: winWidth < sizes.mobileDevice ? '300px' : '350px' }
                            : undefined
                    }
                >
                    {isSelected ===  addItems? (
                        <Box
                            className="inputSearch"
                            marginLeftInput={marginLeftInput}
                        >
                            <StyledForm action="#">
                                <AddInputStyle
                                    placeholder={addItemPlaceholder}
                                    className="inputStyle"
                                    onKeyUp={(e) => {
                                        e.preventDefault();
                                        addItemChange(e);
                                        if (e.key === 'Enter') {
                                            e.target.value = '';
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                        }
                                    }}
                                    fontSize={fontSize}
                                    fontFamily={fontFamily}
                                    color={color}
                                    opacity={opacity}
                                    placeholderMarginLeft={
                                        placeholderMarginLeft
                                    }
                                    padding={
                                        isMobileView()
                                            ? '3px !important'
                                            : isIpad() &&
                                              ' 1.5px 0px !important'
                                    }
                                    // enterkeyhint={'go'}
                                    // onChange={(e)=>addItemChange(e)}
                                    lineHeightInputStyle={lineHeightInputStyle}
                                />
                            </StyledForm>
                        </Box>
                    ) : isSelected === scanItems ? (
                        <ScanItem
                            showExteralCameraPopup={showExteralCameraPopup}
                            handleExtScanCam={handleExtScanCam}
                            scanBarCode={scanBarCode}
                            setScanBarCode={setScanBarCode}
                            counter={counter}
                            setCounter={setCounter}
                            counterMessage={counterMessage}
                            setCounterMessage={setCounterMessage}
                            cursorOnInput={cursorOnInput}
                            setCursorOnInput={setCursorOnInput}
                            handleExternalBarcode={handleExternalBarcode}
                            isConsignment={true}
                            activeTab={activeScanTab}
                            setActiveTab={setActiveScanTab}
                            externalBarcode={externalBarcode}
                            setExternalBarcode={setExternalBarcode}
                        />
                    ) : isSelected === bulkAdd ? (
                        isReportPayment ? (
                            <BulkAdd
                                filteredProduct={filteredProduct}
                                setFilteredProduct={
                                    //         () => {
                                    // setFilteredProduct !== undefined &&
                                    setFilteredProduct
                                    // ();
                                    // }
                                }
                                // setFilteredProduct={setFilteredProduct}
                                isBundle={isBundle}
                                selectedBundleProduct={selectedBundleProduct}
                                setDisableDoneButton={setDisableDoneButton}
                                isReportPayment={isReportPayment}
                                setSuccesMesssage={setSuccesMesssage}
                                setBundleError={setBundleError}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    // () => {
                                    //     setReportPaymentGridData !== undefined &&
                                    setReportPaymentGridData
                                    //         ();
                                    // }
                                }
                            />
                        ) : (
                            <BulkAdd
                                filteredProduct={filteredProduct}
                                setFilteredProduct={setFilteredProduct}
                                isBundle={isBundle}
                                selectedBundleProduct={selectedBundleProduct}
                                setDisableDoneButton={setDisableDoneButton}
                                isReportPayment={isReportPayment}
                                setSuccesMesssage={setSuccesMesssage}
                                setBundleError={setBundleError}
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                bulkValue={bulkAddValue}
                                setBulkValue={setBulkAddValue}
                            />
                        )
                    ) : (
                        <AutoComplete
                            id={
                                id ? `${id}-addItemSearchItem-searchItem` : 'addItemSearchItem-searchItem'
                            }
                            forcePopupIcon={false}
                            isBulkAddSearch={true}
                            isSearchDropdown={true}
                            isProductSearch={true}
                            inputRef={addItemRef}
                            showScrollBar={true}
                            disableClearable={false}
                            disableCloseOnSelect
                            showSearchIcon={true}
                            isFullWidth={true}
                            boxShadow={'0px 3px 6px #00000029'}
                            options={autoCompleteData}
                            value={''}
                            isBundleProduct={isBundleProduct}
                            inputValue={
                                // addItemSearchTerm?.value?
                                // addItemSearchTerm?.value:
                                typeof addItemSearchTerm === 'string'
                                    ? addItemSearchTerm
                                    : ''
                            }
                            clearOnBlur={false}
                            itemTemplate={(option) => {
                                return (
                                    <SearchDropdown
                                        data={option}
                                        productSearchDropdown={true}
                                        cartProducts={
                                            isBundleProduct? isReportPayment? productSelectedItem?.bundleItem:
                                                            productSelectedItem?.children
                                            : isReportPayment? reportPaymentGridData: filteredProduct}
                                        isConsignmentBilling={isConsignmentBilling}
                                        checkLotSerial={checkLotSerial}
                                        onClose={() => {
                                            autoCompleteInputChange && autoCompleteInputChange(null, '', 'clear');
                                            onClose && onClose();
                                        }}
                                    />
                                    // <AutoListItem
                                    //     data={option}
                                    //     onSelectItem={onSelectItem}
                                    //     padding={'10px'}
                                    //     userType={countryISOCode}
                                    // />
                                );
                            }}
                            surgeryShipTo={true}
                            onChange={(value, reason) => {
                                onChange(value, reason);
                                if (reason === 'clear') {
                                    setOpen(false);}
                                else{
                                    setOpen(true);
                                }
                            }}
                            hideNoOptionText={false}
                            placeholder={autoCompletePlaceholder}
                            field='optionValue'
                            optionValue="cfn"
                            onInputChange={(e, value, reason) => {
                                if(value && value.trim() !== ''){
                                autoCompleteInputChange && autoCompleteInputChange(e, value, reason);
                                }
                            }}
                            loading={effectiveLoading}
                            noOptionsText={
                                !effectiveLoading && autoCompleteData?.length === 0
                                    ? t(
                                          'calendar.filterResultsPanel.noOptionText'
                                      )
                                    : effectiveLoading && t('common.loadingText')
                            }
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            onOpen={handleOnOpen}
                            onClose={(e, reason) => {
                                autoCompleteInputChange && autoCompleteInputChange(null, '', 'clear');
                                onClose && onClose(e, reason);
                            }}
                            open={addItemSearchTerm?.value ? false : open}
                            closeOnAllowedReasons={['blur', 'escape', 'empty-input', 'outside-click']}
                            readOnly={addItemSearchTerm?.value}
                            detailsMargin
                            marginLeft={'1.5px'}
                            zIndex={'99999'}
                            isAddItemSearchItem
                        />
                    )}
                </Box>

                {succesMessage.show ? (
                    <Box className="notificationBox">
                        <img src={MDICheckBold}></img>

                        <span className="notificationText">
                            {succesMessage.message}
                        </span>
                    </Box>
                ) : null}
            </Box>
            {scanBarCode ? (
                <ScanBardCodePopUp
                    scanBarCode={scanBarCode}
                    setScanBarCode={setScanBarCode}
                    // accountId={accountId}
                    // territoryId={territoryId}
                    counter={counter}
                    setCounter={setCounter}
                    counterMessage={counterMessage}
                    setCounterMessage={setCounterMessage}
                    addItemChange={addItemChange}
                    isFromScannerBarcode={isFromScannerBarcode}
                    isConsignment={orderType === 'KE'}
                />
            ) : null}
            {showExteralCameraPopup && (
                <ExternalCamera
                    onClose={() => {
                        try {
                            setShowExteralCameraPopup(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onOpen={() => {
                        try {
                            setShowExteralCameraPopup(false);
                            setScanBarCode(true);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {invalidItemPopup && (
                <Popup
                    title={t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.ItemNotFound'
                    )}
                    width={'288px'}
                    height={'160px'}
                    mobileWidthB33Popup={'348px'}
                    onClose={() => setInvalidItemPopup(false)}
                    imgLeftToText={AlertCircleOutline}
                    id={
                        'consignmentBilling-billing-addSearchItems-AddItemSearchItem-popup'
                    }
                >
                    <div style={{ width: '100%' }}>
                        <SubText>
                            {t(
                                'reportUsage.procedure.unidSurgery.SurgeryOrReport.barcodenotreturn'
                            )}
                        </SubText>

                        <ButtonDiv
                            style={{ justifyContent: 'flex-end', marginTop: '12px' }}
                        >
                            <Button
                                id={
                                    'consignmentBilling-addItemSearchItem-okButton'
                                }
                                show={true}
                                width={'80px'}
                                height={'38px'}
                                // primary={true}
                                variant={ButtonStyles?.primary}
                                // borderRadius={'19px'}
                                margin={'5px 0px 5px 5px'}
                                fontSize={'13px'}
                                // fontFamily={'AvenirNextWorld Demi'}
                                clicked={() => setInvalidItemPopup(false)}
                            >
                                OK
                            </Button>
                        </ButtonDiv>
                    </div>
                </Popup>
            )}
        </React.Fragment>
    );
};

export default AddItemSearchItem;
